import React, { useState } from 'react'
import moment from 'moment/moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './CloneEncounterDateModal.scss'
import { addYears, subYears } from 'date-fns'
import GenericConfirmModal from '../../../census/components/ConfirmationModals/GenericConfirmModal'

export default function CloneEncounterDateModal({ onClose, onChange }) {
  const [date, setDate] = useState(new Date())

  return (
    <GenericConfirmModal
      title={'Create new visit on'}
      content={
        <div
          className={'CloneEncounterDateModal'}
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <DatePicker
            selected={date}
            onChange={setDate}
            minDate={subYears(new Date(), 1)}
            maxDate={addYears(new Date(), 1)}
            inline
            fixedHeight
          />
        </div>
      }
      onClose={onClose}
      confirmTxt={'Done'}
      onConfirm={() => {
        onChange(moment(date).format('YYYY-MM-DD'))
      }}
    />
  )
}
